import React from 'react'

import { formatNumber } from '../../../../../../../helpers/numbers'

const BidPricePreview = ({ lineItem }) => {
  const { bid: bidPrice } = lineItem

  if (bidPrice) {
    const formattedBidPrice = formatNumber(bidPrice, { min: 2, max: 2 })

    return <span>Bid Price: {formattedBidPrice}</span>
  }

  return null
}

export default BidPricePreview
